module.exports = __webpack_public_path__ + "img/sign-in-image.fa91c0d3.svg";